import type { FC } from 'react'

import { useEffect } from 'react'
import Lenis from 'lenis'
import { setLenis } from '@/lib/smooth-scroll'

const SmoothScroll: FC = () => {
    useEffect(() => {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)')

        if (reduce.matches) return

        const lenis = new Lenis({
            autoRaf: true,
            lerp: 0.11
        })

        setLenis(lenis)

        return () => {
            lenis.destroy()
            setLenis(null)
        }
    }, [])

    return null
}

export default SmoothScroll
